import { create } from "zustand"

interface AuthStore {
  token: string | null
  username: string | null
  userId: string | null
  publicKeyX: string | null
  publicKeyY: string | null
  privateKey: string | null
  setAuth: (
    token: string,
    username: string,
    userId: string,
    privateKey: string,
    publicKeyX: string,
    publicKeyY: string,
  ) => void
  logout: () => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  token: localStorage.getItem("token") || null,
  username: localStorage.getItem("username") || null,
  userId: localStorage.getItem("userId") || null,
  publicKeyX: localStorage.getItem("publicKeyX") || null,
  publicKeyY: localStorage.getItem("publicKeyY") || null,
  privateKey: localStorage.getItem("privateKey") || null,

  setAuth: (token, username, userId, privateKey, publicKeyX, publicKeyY) => {
    localStorage.setItem("token", token)
    localStorage.setItem("username", username)
    localStorage.setItem("userId", userId)
    localStorage.setItem("privateKey", privateKey)
    localStorage.setItem("publicKeyX", publicKeyX)
    localStorage.setItem("publicKeyY", publicKeyY)

    set({
      token,
      username,
      userId,
      privateKey,
      publicKeyX,
      publicKeyY,
    })
  },

  logout: () => {
    localStorage.clear()
    set({
      token: null,
      username: null,
      userId: null,
      privateKey: null,
      publicKeyX: null,
      publicKeyY: null,
    })
  },
}))
